const deletePlacesStr = {
  toastr: 'Local deletado',
  toastr1: 'deletado com sucesso'
};

export default deletePlacesStr;
